export const isOpera = () => {
    return !!window.opr;
};
